var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { canUseDOM } from '@progress/kendo-react-common';
import { Form } from '@progress/kendo-react-form';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { useLocalization } from '@progress/kendo-react-intl';
import { messages, editorSave, editorCancel, editorTitle } from '../messages';
import { SchedulerEditor } from '../editors/SchedulerEditor';
// tslint:disable:max-line-length
/**
 * Represents the default `form` component rendered by the [KendoReact SchedulerEditItem component]({% slug api_scheduler_scheduleredititem  %}).
 */
export var SchedulerForm = function (props) {
    var onCancel = props.onCancel, onClose = props.onClose, onSubmit = props.onSubmit, other = __rest(props, ["onCancel", "onClose", "onSubmit"]);
    var localization = useLocalization();
    var editSaveMessage = localization.toLanguageString(editorSave, messages[editorSave]);
    var editCancelMessage = localization.toLanguageString(editorCancel, messages[editorCancel]);
    var editorTitleMessage = localization.toLanguageString(editorTitle, messages[editorTitle]);
    var handleCancel = React.useCallback(function (syntheticEvent) {
        if (onCancel) {
            onCancel.call(undefined, { syntheticEvent: syntheticEvent });
        }
    }, [onCancel]);
    var handleClose = React.useCallback(function (_a) {
        var syntheticEvent = _a.syntheticEvent;
        if (onClose) {
            onClose.call(undefined, { syntheticEvent: syntheticEvent });
        }
    }, [onClose]);
    var handleSubmit = React.useCallback(function (dataItem, syntheticEvent) {
        if (onSubmit) {
            onSubmit.call(undefined, { value: dataItem, syntheticEvent: syntheticEvent });
        }
    }, [onSubmit]);
    return canUseDOM
        ? ReactDOM.createPortal((React.createElement(Form, __assign({ initialValues: props.dataItem, onSubmit: handleSubmit, render: function (renderProps) { return (React.createElement(Dialog, { title: editorTitleMessage, minWidth: 600, onClose: handleClose, className: "k-scheduler-edit-dialog", style: { zIndex: 90 } },
                React.createElement(SchedulerEditor, __assign({}, renderProps)),
                React.createElement(DialogActionsBar, null,
                    React.createElement("button", { className: "k-button", disabled: !renderProps.allowSubmit, onClick: renderProps.onSubmit }, editSaveMessage),
                    React.createElement("button", { className: "k-button", onClick: handleCancel }, editCancelMessage)))); } }, other))), document && document.body)
        : null;
};
//# sourceMappingURL=SchedulerForm.js.map